import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductPage } from '../../entities/control-tables/product-page';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class ProductPageRequest extends BaseRequest {

    productPage : ProductPage

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.productPage = new ProductPage()
  }
}